import { createContext, useContext, useState, useCallback } from "react";
import DemoModal from "../components/DemoModal";

const DemoContext = createContext(null);

export function DemoProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openDemo = useCallback(() => setOpen(true), []);
  const closeDemo = useCallback(() => setOpen(false), []);
  return (
    <DemoContext.Provider value={{ openDemo, closeDemo }}>
      {children}
      <DemoModal open={open} onClose={closeDemo} />
    </DemoContext.Provider>
  );
}

export const useDemo = () => useContext(DemoContext);
